export default __webpack_public_path__ + "static/media/interreg-ipa.2d0b2804.png";